// import React from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import {useNavigate, useParams} from 'react-router'
// import AllProduct from '../component/AllProduct'
// import { addCartItem } from '../redux/productSlice'

// function Menu() {
//   const dispatch= useDispatch()
//   const navigate= useNavigate()
//   const {filterby}= useParams() //this will have the id of the product we click on
//   const productData= useSelector(state=> state.product.productList)

//   const productDisplay= productData.filter(el=> el._id === filterby)[0]

//   const handleAddCartProduct= (e)=>{
//       // e.stopPropagation();
//       dispatch(addCartItem(productDisplay))
//   };

//   const handleBuy= ()=>{
//     dispatch(addCartItem(productDisplay))
//     navigate("/cart")
//   }

//   return (
//     <div className='p-2 md:p-4'>
//       <div className='w-full max-w-4xl m-auto md:flex bg-white'>
//         <div className='max-w-sm overflow-hidden w-full p-5'>
//           <img src={productDisplay.image} alt='prodctImage' className='hover:scale-105 transition-all h-full' />
//         </div>

//         <div className='flex flex-col gap-1'>
//           <h3 className='font-semibold text-slate-600 capitalize text-2xl md:text-4xl'>
//             {productDisplay.name}
//             </h3>
//           <p className='text-slate-500 font-medium text-2xl'>{productDisplay.category}</p>
//           <p className= 'font-bold md:text-2xl'>
//             <span className='text-red-500'>$</span>
//             <span>{productDisplay.price}</span>
//           </p>
//           <div className='flex gap-3'>
//             <button onClick={handleBuy} className='bg-yellow-500 py-1 mt-2 rounded hover:bg-yellow-600 min-w-[100px]'>Buy</button>
//             <button onClick={handleAddCartProduct} className='bg-yellow-500 py-1 mt-2 rounded hover:bg-yellow-600 min-w-[100px]'>Add to Cart</button>
//           </div>
//           <div>
//             <p className='text-slate-600 font-medium'>Description : </p>
//             <p>{productDisplay.description}</p>
//           </div>


//         </div>
//       </div>

//       <AllProduct heading={"Related Products"}/>

//     </div>
//   )
// }

// export default Menu


import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { addCartItem } from '../redux/productSlice';
import AllProduct from '../component/AllProduct';
import { BsCartPlusFill, BsLightningChargeFill, BsShieldFillCheck } from 'react-icons/bs';
import { MdVerified, MdOutlineLocalShipping } from 'react-icons/md';
import { HiArrowLeft } from 'react-icons/hi';
import { TbCertificate } from 'react-icons/tb';

const FEATURE_CHIPS = ['ISI Mark', '2-Year Warranty', 'Flame Retardant', 'RoHS Compliant', 'BIS Certified'];

// ── Skeleton ──────────────────────────────────────────────────────────────────
function PageSkeleton() {
  return (
    <div className="max-w-5xl mx-auto py-10 px-4 md:px-6">
      <div className="glass rounded-2xl overflow-hidden md:flex gap-0">
        <div className="skeleton md:w-2/5" style={{ height: 400, borderRadius: 0 }} />
        <div className="md:w-3/5 p-8 space-y-4">
          <div className="skeleton h-4 w-24 rounded-full" />
          <div className="skeleton h-10 w-3/4 rounded" />
          <div className="skeleton h-8 w-1/3 rounded" />
          <div className="skeleton h-4 w-full rounded" />
          <div className="skeleton h-4 w-4/5 rounded" />
          <div className="skeleton h-12 w-full rounded-xl mt-8" />
        </div>
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
// ── Main ──────────────────────────────────────────────────────────────────────
export default function Menu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { filterby } = useParams();
  const productList = useSelector(s => s.product.productList);
  const product = productList.find(p => p._id === filterby);
  const [imgZoom, setImgZoom] = useState(false);

  if (!product) return <PageSkeleton />;

  const handleAdd = () => dispatch(addCartItem(product));
  const handleBuy = () => { dispatch(addCartItem(product)); navigate('/cart'); };

  return (
    <div
      className="min-h-screen py-10 px-4 md:px-6"
      style={{
        background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 60%, var(--bg-surface) 100%)',
      }}
    >
      <div className="max-w-5xl mx-auto">

        {/* Back */}
        <button
          onClick={() => navigate(-1)}
          className="
            flex items-center gap-2 mb-6 text-sm
            transition-all duration-200
            hover:text-[var(--indigo-light)]
          "
          style={{ color: 'var(--text-muted)' }}
        >
          <HiArrowLeft />
          <span className="font-mono text-xs tracking-wider">Back</span>
        </button>

        {/* ── Product card ──────────────────────────────────────────────── */}
        <div
          className="glass rounded-2xl overflow-hidden md:flex mb-12 animate-fade-up"
          style={{ border: '1px solid var(--glass-border)' }}
        >
          {/* Image panel */}
          <div
            className="
              md:w-2/5 flex items-center justify-center p-8 md:p-12 relative overflow-hidden
              cursor-zoom-in
            "
            style={{ background: 'var(--bg-surface)', minHeight: 320 }}
            onClick={() => setImgZoom(true)}
          >
            {/* Ambient glow */}
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background: 'radial-gradient(circle at 50% 50%, rgba(99,102,241,0.10) 0%, transparent 65%)',
              }}
            />
            {/* Top edge line */}
            <div
              className="absolute top-0 left-0 right-0 h-px"
              style={{ background: 'var(--grad-brand)', opacity: 0.5 }}
            />
            <img
              src={product.image}
              alt={product.name}
              className="
                relative z-10 object-contain
                hover:scale-105 transition-transform duration-500
                drop-shadow-2xl
              "
              style={{ maxHeight: 280 }}
            />
            <span
              className="absolute bottom-3 right-3 badge text-[0.55rem]"
              style={{ opacity: 0.5 }}
            >
              Click to zoom
            </span>
          </div>

          {/* Info panel */}
          <div className="md:w-3/5 p-8 md:p-10 flex flex-col gap-4">
            <div className="flex flex-wrap gap-2">
              <span className="badge">{product.category}</span>
              <span className="badge-cyan flex items-center gap-1">
                <MdVerified className="text-xs" /> ISI Certified
              </span>
            </div>

            <h1
              className="font-display font-bold capitalize leading-tight"
              style={{
                fontSize: 'clamp(1.5rem, 4vw, 2.4rem)',
                color: 'var(--text-primary)',
              }}
            >
              {product.name}
            </h1>

            {/* Price */}
            <div>
              <p className="font-mono text-xs mb-1" style={{ color: 'var(--text-muted)', letterSpacing: '0.15em' }}>
                UNIT PRICE
              </p>
              <p className="font-display text-4xl font-bold">
                <span style={{ color: 'var(--coral)' }}>₹</span>
                <span className="text-gradient">{product.price}</span>
              </p>
            </div>

            <div className="divider" />

            {/* Description */}
            {product.description && (
              <div>
                <p className="font-mono text-xs mb-2" style={{ color: 'var(--text-muted)', letterSpacing: '0.12em' }}>
                  DESCRIPTION
                </p>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                  {product.description}
                </p>
              </div>
            )}

            {/* Feature chips */}
            <div className="flex flex-wrap gap-2">
              {FEATURE_CHIPS.map(chip => (
                <span
                  key={chip}
                  className="text-xs px-3 py-1 rounded-full border"
                  style={{
                    borderColor: 'var(--glass-border)',
                    color: 'var(--text-muted)',
                    background: 'var(--glass-1)',
                  }}
                >
                  {chip}
                </span>
              ))}
            </div>

            {/* Trust icons */}
            <div className="flex flex-wrap gap-4 py-1">
              {[
                { icon: <BsShieldFillCheck />, label: '2yr Warranty' },
                { icon: <MdOutlineLocalShipping />, label: 'Free Shipping' },
                { icon: <TbCertificate />, label: 'BIS Approved' },
              ].map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 text-xs"
                  style={{ color: 'var(--text-muted)' }}>
                  <span style={{ color: 'var(--indigo-light)' }}>{icon}</span>
                  {label}
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex gap-3 mt-2 flex-wrap">
              <button
                onClick={handleBuy}
                className="btn-primary flex-1 min-w-[130px] py-3.5 rounded-xl
                           flex items-center justify-center gap-2"
              >
                <BsLightningChargeFill />
                Buy Now
              </button>
              <button
                onClick={handleAdd}
                className="btn-ghost flex-1 min-w-[130px] py-3.5 rounded-xl
                           flex items-center justify-center gap-2"
              >
                <BsCartPlusFill />
                Add to Cart
              </button>
            </div>
          </div>
        </div>

        {/* Related */}
        <AllProduct heading="Related Products" />
      </div>

      {/* ── Image lightbox ─────────────────────────────────────────────── */}
      {imgZoom && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center
                     bg-black/80 backdrop-blur-sm animate-fade-in cursor-zoom-out"
          onClick={() => setImgZoom(false)}
        >
          <img
            src={product.image}
            alt={product.name}
            className="max-w-[90vw] max-h-[85vh] object-contain animate-scale-up
                       rounded-2xl shadow-2xl"
          />
        </div>
      )}
    </div>
  );
}
